import Rest from '../Rest'

export default class FormProtocolQueryService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/form_protocol_query'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getByProtocol(form_type: String, data: any){
    return this.get(`/${form_type}`,data)
  }

  getHistory(form_type: String, data: any){
    return this.get(`/${form_type}/history`,data)
  }
}
